import React, { FC } from 'react';
import styled from 'styled-components';

const Wrapper = styled.section`
  .st0 {
    fill: none;
    stroke: url(#SVGID_1_);
    stroke-width: 4;
    stroke-miterlimit: 10;
  }
  .st1 {
    fill: none;
    stroke: url(#SVGID_2_);
    stroke-width: 4;
    stroke-miterlimit: 10;
  }
  .st2 {
    fill: none;
  }
  .st4 {
    font-size: 11px;
  }
  .st5 {
    fill: ${(props) => props.theme.backgroundColor};
    stroke: url(#SVGID_3_);
    stroke-width: 2;
    stroke-miterlimit: 10;
  }
  .st11 {
    fill: ${(props) => props.theme.backgroundColor};
    stroke: url(#SVGID_9_);
    stroke-width: 2;
    stroke-miterlimit: 10;
  }
`;

const ProcessTimeline: FC = () => (
  <Wrapper>
    <svg width="100%" viewBox="0 0 405.3 132.2">
      <linearGradient
        id="SVGID_1_"
        gradientUnits="userSpaceOnUse"
        x1="101.2796"
        y1="64.533"
        x2="243.1699"
        y2="64.533"
      >
        <stop offset="0" style={{ stopColor: '#BF8CFF' }} />
        <stop offset="1" style={{ stopColor: '#78D2EB' }} />
      </linearGradient>
      <path
        className="st0"
        d="M101.3,48c37.1,0,39.3,33.2,70.3,33.2S210.2,48,243.2,48"
      />
      <linearGradient
        id="SVGID_2_"
        gradientUnits="userSpaceOnUse"
        x1="30.3344"
        y1="47.9512"
        x2="385.184"
        y2="47.9512"
      >
        <stop offset="0" style={{ stopColor: '#FF3BB8' }} />
        <stop offset="1" style={{ stopColor: '#AB69FF' }} />
      </linearGradient>
      <line className="st1" x1="30.3" y1="48" x2="385.2" y2="48" />
      <rect x="7.2" y="5.3" className="st2" width="46.2" height="28.1" />
      <text transform="matrix(1 0 0 1 11.6687 14.1896)">
        <tspan x="0" y="0" className="st3 st4 fill-secondary">
          rubber{' '}
        </tspan>
        <tspan x="4.8" y="16" className="st3 st4 fill-secondary">
          mold
        </tspan>
      </text>
      <rect x="212" y="21.3" className="st2" width="62.3" height="14.1" />
      <text
        transform="matrix(1 0 0 1 216.1884 30.1896)"
        className="st3 st4 fill-secondary"
      >
        autoclave
      </text>
      <rect x="291" y="21.3" className="st2" width="46.2" height="11.2" />
      <text
        transform="matrix(1 0 0 1 292.005 30.1896)"
        className="st3 st4 fill-secondary"
      >
        burnout
      </text>
      <rect x="362" y="21.3" className="st2" width="46.2" height="11.2" />
      <text
        transform="matrix(1 0 0 1 373.1567 30.1896)"
        className="st3 st4 fill-secondary"
      >
        cast
      </text>
      <rect x="78.2" y="5.3" className="st2" width="46.2" height="28.1" />
      <text transform="matrix(1 0 0 1 90.588 14.1896)">
        <tspan x="0" y="0" className="st3 st4 fill-secondary">
          wax{' '}
        </tspan>
        <tspan x="-10" y="16" className="st3 st4 fill-secondary">
          pattern
        </tspan>
      </text>
      <rect x="149.1" y="5.3" className="st2" width="46.2" height="28.1" />
      <text transform="matrix(1 0 0 1 155.3349 14.1896)">
        <tspan x="0" y="0" className="st3 st4 fill-secondary">
          invest{' '}
        </tspan>
        <tspan x="0" y="16" className="st3 st4 fill-secondary">
          (flask)
        </tspan>
      </text>
      <rect x="149.1" y="97.3" className="st2" width="46.2" height="28.1" />
      <text transform="matrix(1 0 0 1 155.3349 106.1579)">
        <tspan x="0" y="0" className="st3 st4 fill-secondary">
          invest{' '}
        </tspan>
        <tspan x="-0.5" y="16" className="st3 st4 fill-secondary">
          (shell)
        </tspan>
      </text>
      <g>
        <linearGradient
          id="SVGID_3_"
          gradientUnits="userSpaceOnUse"
          x1="164.3976"
          y1="81.1148"
          x2="180.0519"
          y2="81.1148"
        >
          <stop offset="0" style={{ stopColor: '#BF8CFF' }} />
          <stop offset="1" style={{ stopColor: '#78D2EB' }} />
        </linearGradient>
        <circle className="st5" cx="172.2" cy="81.1" r="6.8" />
      </g>
      <linearGradient
        id="SVGID_4_"
        gradientUnits="userSpaceOnUse"
        x1="93.4524"
        y1="47.9512"
        x2="109.1068"
        y2="47.9512"
      >
        <stop offset="0" style={{ stopColor: '#FF3BB8' }} />
        <stop offset="1" style={{ stopColor: '#8F35FF' }} />
      </linearGradient>
      <circle className="st11" cx="101.3" cy="48" r="6.8" />
      <linearGradient
        id="SVGID_5_"
        gradientUnits="userSpaceOnUse"
        x1="235.3427"
        y1="47.9512"
        x2="250.9971"
        y2="47.9512"
      >
        <stop offset="0" style={{ stopColor: '#FF3BB8' }} />
        <stop offset="1" style={{ stopColor: '#8F35FF' }} />
      </linearGradient>
      <circle className="st11" cx="243.2" cy="48" r="6.8" />
      <linearGradient
        id="SVGID_6_"
        gradientUnits="userSpaceOnUse"
        x1="306.2879"
        y1="47.9512"
        x2="321.9422"
        y2="47.9512"
      >
        <stop offset="0" style={{ stopColor: '#FF3BB8' }} />
        <stop offset="1" style={{ stopColor: '#8F35FF' }} />
      </linearGradient>
      <circle className="st11" cx="314.1" cy="48" r="6.8" />
      <linearGradient
        id="SVGID_7_"
        gradientUnits="userSpaceOnUse"
        x1="377.233"
        y1="47.9512"
        x2="392.8874"
        y2="47.9512"
      >
        <stop offset="0" style={{ stopColor: '#FF3BB8' }} />
        <stop offset="1" style={{ stopColor: '#8F35FF' }} />
      </linearGradient>
      <circle className="st11" cx="385.1" cy="48" r="6.8" />
      <linearGradient
        id="SVGID_8_"
        gradientUnits="userSpaceOnUse"
        x1="164.3976"
        y1="47.9512"
        x2="180.0519"
        y2="47.9512"
      >
        <stop offset="0" style={{ stopColor: '#FF3BB8' }} />
        <stop offset="1" style={{ stopColor: '#8F35FF' }} />
      </linearGradient>
      <circle className="st11" cx="172.2" cy="48" r="6.8" />
      <linearGradient
        id="SVGID_9_"
        gradientUnits="userSpaceOnUse"
        x1="22.5072"
        y1="47.9512"
        x2="38.1616"
        y2="47.9512"
      >
        <stop offset="0" style={{ stopColor: '#FF3BB8' }} />
        <stop offset="1" style={{ stopColor: '#8F35FF' }} />
      </linearGradient>
      <circle className="st11" cx="30.3" cy="48" r="6.8" />
    </svg>
  </Wrapper>
);

export default ProcessTimeline;
